import React from 'react';
import { Box, Typography, Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import { Language, LockOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updatePreferences } from '../firebase/dataHandler';

export default function LanguageSwitcher({ isPremium }) {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    updatePreferences({ language: lng }).catch(console.error);
    handleClose();
  };

  return (
    <>
      <Tooltip title="Language Settings">
        <IconButton onClick={handleOpen} sx={{ color: 'var(--text-secondary)', '&:hover': { background: 'var(--bg-card-hover)', color: 'var(--accent-green)' } }}>
          <Language />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ sx: { mt: 1, borderRadius: 3, border: '1px solid var(--border-subtle)', background: 'var(--bg-card)', minWidth: '180px', boxShadow: 'var(--shadow-md)' } }}
      >
        <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid var(--border-subtle)', mb: 1 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'Inter' }}>Select Language</Typography>
        </Box>

        {!isPremium ? (
          <Box sx={{ px: 2, py: 2, textAlign: 'center' }}>
            <Box sx={{ background: 'rgba(255,215,0,0.1)', p: 1, borderRadius: '50%', display: 'inline-flex', mb: 1 }}>
              <LockOutlined sx={{ color: '#FFD700', fontSize: 24 }} />
            </Box>
            <Typography sx={{ fontSize: 12, color: 'var(--text-secondary)', mb: 2, fontFamily: 'Inter' }}>
              Multi-language support is available for Premium users.
            </Typography>
            <Typography 
              onClick={() => { handleClose(); navigate('/subscription'); }}
              sx={{ fontSize: 13, fontWeight: 700, color: 'var(--accent-green)', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
            >
              Upgrade to PRO
            </Typography>
          </Box>
        ) : (
          <>
            <MenuItem 
              onClick={() => changeLanguage('en')} 
              selected={i18n.language === 'en'}
              sx={{ fontSize: 14, fontFamily: 'Inter', '&.Mui-selected': { background: 'rgba(21, 195, 88, 0.1)', color: 'var(--accent-green)' } }}
            >
              English
            </MenuItem>
            <MenuItem 
              onClick={() => changeLanguage('ta')} 
              selected={i18n.language === 'ta'}
              sx={{ fontSize: 14, fontFamily: 'Inter', '&.Mui-selected': { background: 'rgba(21, 195, 88, 0.1)', color: 'var(--accent-green)' } }}
            >
              தமிழ் (Tamil)
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}
